import React from "react";
import classes from "./APIPlaygroundComponents.module.scss";

const partials = [
  {
    name: "Minimal",
    description:
      "suitable for light clients that can only generate classic invoices",
  },
  {
    name: "Normal",
    description:
      "the default value and is suitable for all invoice types, including advances, credit notes, and others",
  },
  {
    name: "Maximal",
    description:
      "supports the same invoice types as Normal, but includes all (rarely used) invoice data defined by the Peppol and UBL formats",
  },
];

const Instructions = ({ apiData }) => {
  // console.log(apiData);
  return (
    <div className={classes["instruction-container"]}>
      <div className={classes["instruction-content"]}>
        <span className={classes.subtitle}>Instructions</span>
        <hr />
        <div>
          <span className={classes.subtitle}>Description</span>
          <p>{apiData.description}</p>
          {"Complexity" in apiData.properties && (
            <>
              <span className={classes.subtitle}>Complexity</span>
              <ul>
                {partials.map((partial) => {
                  return (
                    <li key={partial.name}>
                      <span>
                        <span className={classes.underline}>
                          {partial.name}:
                        </span>{" "}
                        {partial.description}
                      </span>
                    </li>
                  );
                })}
              </ul>
            </>
          )}
          <span className={classes.subtitle}>Request object</span>
          <ul>
            {Object.keys(apiData.properties).map((key) => {
              const { title, description, type, items, properties } =
                apiData.properties[key];
              return (
                <li key={key}>
                  <span className={classes.underline}>{title}</span>
                  <ul>
                    <li>
                      type: {type} {items && `of ${items.type}s`}
                    </li>
                    <li>description: {description}</li>
                  </ul>
                  {properties && (
                    <ul style={{ marginLeft: "2rem" }}>
                      {Object.keys(properties).map((prop) => {
                        const { title, description, type, items } =
                          apiData.properties[key].properties[prop];
                        return (
                          <li key={Math.random().toString()}>
                            <span>{title}</span>
                            <ul>
                              <li>
                                type: {type} {items && `of ${items.type}s`}
                              </li>
                              <li>description: {description}</li>
                            </ul>
                          </li>
                        );
                      })}
                    </ul>
                  )}
                </li>
              );
            })}
          </ul>
          {apiData?.required?.length > 0 && (
            <>
              <span className={classes.subtitle}>Required fields:</span>
              <ul>
                {apiData.required.map((field) => (
                  <li key={Math.random().toString()}>{field}</li>
                ))}
              </ul>
            </>
          )}
          {apiData["$d3pro"].results && (
            <>
              <span className={classes.subtitle}>Response object</span>
              <ul>
                <li>{apiData["$d3pro"].results[0].description}</li>
                <li>
                  <span className={classes.underline}>Status:</span>{" "}
                  <ul>
                    <li>
                      type:{" "}
                      {apiData["$d3pro"].results[0].properties.Status.type}
                    </li>
                    <li>
                      description:{" "}
                      {
                        apiData["$d3pro"].results[0].properties.Status
                          .description
                      }
                    </li>
                  </ul>
                </li>
                <li>
                  <span className={classes.underline}>Result:</span>{" "}
                  {/* {apiData["$d3pro"].results[0].properties.Result.description} */}
                  <ul>
                    <li>
                      type:{" "}
                      {apiData["$d3pro"].results[0].properties.Result.type}
                    </li>
                    <li>
                      description:{" "}
                      {
                        apiData["$d3pro"].results[0].properties.Result
                          .description
                      }
                    </li>
                  </ul>
                </li>
                <li>
                  <span className={classes.underline}>Reason:</span>{" "}
                  {/* {apiData["$d3pro"].results[0].properties.Reason.description} */}
                  <ul>
                    <li>
                      type:{" "}
                      {apiData["$d3pro"].results[0].properties.Reason.type}
                    </li>
                    <li>
                      description:{" "}
                      {
                        apiData["$d3pro"].results[0].properties.Reason
                          .description
                      }
                    </li>
                  </ul>
                </li>
              </ul>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Instructions;
